import Axios from 'axios';
import Apis from '../../config/Apis';
import { hideLoading, showLoading, showAlert } from '../Actions/GeneralActions';
import { headers } from '../../utills';

export const VideoCallMiddleware = {

    generateVideoCallToken: ({ id }) => {
        return dispatch => {
            dispatch(showLoading())
            return new Promise(async (resolve, reject) => {
                try {
                    let formdata = new FormData()
                    formdata.append('id', id)
                    const data = await Axios.post(Apis.generateGroupVideoCallToken, formdata, await headers.config())
                    if (data?.status == 200) {
                        resolve(data?.data?.data)
                    }
                } catch (error) {
                    reject(error);
                    dispatch(
                        showAlert({
                            title: 'generateVideoCallToken',
                            message: error?.response?.data?.message,
                            type: 'Error',
                            status: error?.response?.status,
                        }),
                    );
                }
                finally {
                    dispatch(hideLoading())
                }
            })
        }
    },

    generateSingleCallToken: ({ id }) => {
        return dispatch => {
            dispatch(showLoading())
            return new Promise(async (resolve, reject) => {
                try {
                    let formdata = new FormData()
                    formdata.append('receiver_id', id)
                    const data = await Axios.post(Apis.generateVideoCallToken, formdata, await headers.config())
                    if (data?.status == 200) {
                        resolve(data?.data?.data)
                    }
                } catch (error) {
                    reject(error);
                    dispatch(
                        showAlert({
                            title: 'generateVideoCallToken',
                            message: error?.response?.data?.message,
                            type: 'Error',
                            status: error?.response?.status,
                        }),
                    );
                }
                finally {
                    dispatch(hideLoading())
                }
            })
        }
    },

    declineCall: ({ receiver_id, caller_id, channel ,chat_room_id}) => {
        return dispatch => {
            dispatch(showLoading())
            return new Promise(async (resolve, reject) => {
                try {
                    let formdata = new FormData()
                    formdata.append('channel_name', channel)
                    if (receiver_id)
                        formdata.append('receiver_id', receiver_id)
                    if (caller_id)
                        formdata.append('caller_id', caller_id)
                    // if (chat_room_id)
                    //     formdata.append('chat_room_id', chat_room_id)
                    const data = await Axios.post(Apis.declineCall, formdata, await headers.config())
                    if (data?.status == 200) {
                        resolve(true)
                    }
                } catch (error) {
                    reject(error);
                    dispatch(
                        showAlert({
                            title: 'declineCall',
                            message: error?.response?.data?.message,
                            type: 'Error',
                            status: error?.response?.status,
                        }),
                    );
                }
                finally {
                    dispatch(hideLoading())
                }
            })
        }
    },

    acceptCall: () => {
        return dispatch => {
            return new Promise(async (resolve, reject) => {
                try {
                    const data = await Axios.get(Apis.acceptCall, await headers.config())
                    if (data?.status == 200) {
                        resolve(true)
                    }
                } catch (error) {
                    reject(error);
                    dispatch(
                        showAlert({
                            title: 'acceptCall',
                            message: error?.response?.data?.message,
                            type: 'Error',
                            status: error?.response?.status,
                        }),
                    );
                }
            })
        }
    },


}